import React, { useState, useEffect } from 'react'

import { Modal, Button, Header, Input, Icon } from 'semantic-ui-react'

import './RxBagVerificationModal.css'


const RxBagVerificationModal = ({ open, verify, toCheckCount, checkedCount, close, confirmWrongRXScanOpen }) => {
  const [input, setInputState] = useState("");
  const [isLoading, setisLoadingState] = useState(false);
  const inputRef = React.createRef()

  const focusInput = () => {
    if (open && inputRef && inputRef.current) {
      inputRef.current.focus()
    }
  }

  useEffect(() => {
      onInputBlur();
  }, [confirmWrongRXScanOpen]);

  const setInputValue = (ev) => {
    let value = ev.target.value
    var parsedValue = parseInt(value);
    var newValue = ""
    if (parsedValue) {
      var parsedValueString = parsedValue.toString()
      if (parsedValue > 0) {
        newValue = parsedValueString
      } else {
        //If they key is not a number, we remove it
        newValue = parsedValueString.substr(0, parsedValueString.length - 1)
      }
    }
    setInputState(newValue)
  }

  const onInputKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      setisLoadingState(true);
      verify(input)
      setTimeout(() => {
        setInputState("");
        setisLoadingState(false);
      }, 300)
    }
  }

  const onInputBlur = () => {
    if (!confirmWrongRXScanOpen) {
      focusInput()
    }
  }

  const onCancel = () => {
    close();
    setTimeout(() => {
      setInputState("");
      setisLoadingState(false);
    }, 300)
  }

  return (
    <Modal
      open={open}
      size="small"
      className="RxBagVerificationModal"
      onBlur={() => onInputBlur()}
      onClick={() => onInputBlur()}>
      <Header>
        <Header.Content style={{ color:"red", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
          <div><Icon name="warning sign" color="red"></Icon>SKANNA RX-PÅSE</div>
          <div>{`${checkedCount}/${toCheckCount}`}</div>
        </Header.Content>
      </Header>
      <Modal.Content>
        <div className="InputContainer">
          <Input
            className="InputElement"
            autoFocus
            autoComplete="off"
            disabled={confirmWrongRXScanOpen}
            ref={inputRef}
            value={input}
            loading={isLoading}
            placeholder={"RX-påse"}
            onChange={(ev) => setInputValue(ev)}
            onKeyPress={(ev) => onInputKeyPress(ev)} />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={() => onCancel()}>
          AVBRYT
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default RxBagVerificationModal;